import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function SecurityAnalystRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Security Analyst Career Roadmap`}
      subtitle="Security Operations Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-security-analyst-roadmap.pdf"
      roleKey={roleKey || "securityanalyst"}
    />
  );
}

